import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { SubmitApplicationPrintComponent } from '../submit-application-print/submit-application-print.component';
import { PrintService } from 'src/app/services/print.service';
import { SubmitDetail } from 'src/app/stores/submit-detail.store';
import { ActivatedRoute, Router } from '@angular/router';
import { ConvertService, pushToArray } from 'src/app/services/convert.service';
import { DataService } from 'src/app/services/data.service';
import { FormGroup, AbstractControl, FormBuilder, Validators } from '@angular/forms';
import { CommentStore } from 'src/app/stores/comment.store';
import { AngularFirestore } from '@angular/fire/firestore';
import { Auth } from 'src/app/stores/auth.store';
import { statusObj } from 'src/app/dummy/status';
import { FileManagerStore } from 'src/app/stores/filemanager.store';
import { BreakpointState, BreakpointObserver } from '@angular/cdk/layout';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { chunkArray } from 'src/app/services/mapping.service';

@Component({
  selector: 'app-submit-application-detail',
  templateUrl: './submit-application-detail.component.html',
  styleUrls: ['./submit-application-detail.component.scss']
})
export class SubmitApplicationDetailComponent implements OnInit {

  @Input() title: string;
  @Input() data: any = null;
  @Input() link: string;
  @Input() backlink: string;
  @Input() collection: string;
  @Input() isHide: boolean;

  @Input() printTemplate: number;

  @Output() onDelete = new EventEmitter();
  @Output() cancelSubmit = new EventEmitter();
  @ViewChild('content') content: ElementRef;


  @ViewChild('editor') editor;

  modules = {};

  form: FormGroup;
  comment: AbstractControl;

  detailData: any;
  isReturn: any;
  isCutStock: any;
  isDelivery: any;

  selectedFiles: any;


  formUpload: FormGroup;
  file: AbstractControl;
  id;
  ismobile = false;
  printTemplateData;

  constructor(
    public ps: PrintService,
    private dialog: MatDialog,
    public detail: SubmitDetail,
    private routes: ActivatedRoute,
    private router: Router,
    private ds: DataService,
    private fb: FormBuilder,
    public cm: CommentStore,
    private afs: AngularFirestore,
    public auth: Auth,
    private snackBar: MatSnackBar,
    public fm: FileManagerStore,
    public breakpointObserver: BreakpointObserver,

  ) {
    this.modules = {
      // imageResize: {},
      syntax: false,
      toolbar: [
        [{ header: [1, 2, false] }],
        ['bold', 'italic', 'underline'],
        ['formula'],
        ['image', 'code-block']
      ]
    }
  }

  ngOnInit() {
    this.breakpointObserver
      .observe(['(max-width: 768px)'])
      .subscribe((state: BreakpointState) => {
        if (state.matches) {
          this.ismobile = state.matches;
        } else {
          this.ismobile = state.matches;
        }
      });
    this.form = this.fb.group({
      comment: [null, Validators.required]
    })
    this.formUpload = this.fb.group({
      file: [null, Validators.required]
    });


    this.comment = this.form.controls['comment']
    this.routes.params.subscribe(async param => {
      if (param && param.id) {
        this.detail.detailCollectionByCompany(this.collection, param.id, this.auth.selectedCompany.key, async data => {
          if (data) {
            this.cm.fetchComment(this.collection, data);
            this.detailData = ConvertService.orderBy(data.registerCoItems, 'created_at');
            const { registerCoItems } = data;
            if (registerCoItems && registerCoItems.length > 0) {
              const registerCo = registerCoItems.map(m => (m.registerCoKey));
              if (registerCo && registerCo.length > 0) {
                const chunkData = chunkArray(registerCo, 10); 
                let COData = [];
                for await (const f of chunkData) {
                  const CODoc = pushToArray(await this.ds.dbRef().collection('company').doc(this.auth.selectedCompany.key).collection('register_co', ref => ref.where("key", "in", f)).get().toPromise());
                  COData.push(...CODoc);
                }
                this.isReturn = COData.filter(f => f.returnAppKey)[0];
                this.isDelivery = COData.filter(f => f.deliveryCoKey)[0];
                this.isCutStock = COData.filter(f => f.registerCutStockRef)[0];
              }
            }
          }
        });
      }
    })

    if (this.printTemplate) {
      this.detail.fetchCollectionPrintTemplate(this.auth.selectedCompany.key, Number(this.printTemplate), data => {
        this.printTemplateData = ConvertService.orderByDesc(data, 'updated_at')
      })
    }

  }

  editItem = null;
  editComment(item) {
    this.editItem = item
    this.form.patchValue({
      comment: item.comment
    })
  }

  postComment(f, data) {
    if (this.form.valid) {
      const isEdit = this.editItem ? true : false;
      const key = this.editItem ? this.editItem.key : this.afs.createId()
      const item = {
        key: key,
        refKey: data.key,
        comment: f.comment,
        created_at: this.editItem ? this.editItem.created_at : new Date(),
        created_by: this.editItem ? this.editItem.created_by : this.auth.user,
        updated_at: new Date(),
        updated_by: this.auth.user,
        status: statusObj.active,
        isEdit: isEdit,
      }
      this.cm.addCommentByCompany(this.collection, this.auth.selectedCompany.key, item, (success, res) => {
        // this.snackBar.open("Comment has been submit successful.", "Done", { duration: 100 });
        this.editItem = null;
        this.form.reset();
      })
    }

  }

  onSelectedFile(event) {
    this.selectedFiles = event;
    this.uploadFile()
  }

  uploadFile() {
    if (this.formUpload.valid) {
      this.fm.addFileManagerByCompany(this.router.url, this.auth.selectedCompany.name_en, this.collection, this.auth.selectedCompany.key, this.id, this.auth.user, this.selectedFiles, success => { })
    }
  }
  deleteFile(file) {
    this.fm.deleteFileDataByCompany(this.auth.selectedCompany.name_en, this.collection, this.auth.selectedCompany.key, file, (success, res) => {
      if (success)
        this.snackBar.open("File has been delete successful.", "Done", { duration: 100 });
    })
  }

  print() {
    this.ps.print('#print', 'a4');
  }
  printMasterList() {
    const item = this.data
    const collection = this.collection
    const dialogRef = this.dialog.open(SubmitApplicationPrintComponent, {
      data: { item, collection, printTemplateData: this.printTemplateData },
      panelClass: 'print-master-panel',
      width: '',
      height: '',
      role: 'dialog',
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  delete(item: any) {
    this.onDelete.emit(item);
  }
  cancel(item: any) {
    this.cancelSubmit.emit(item);
  }

  getStatus(data) {
    if (!data) return true;
    let show = true;
    const { isDelete, register_status } = data;
    if (isDelete == true)
      show = false
    else if (register_status.key == 'canceled')
      show = false

    return show;
  }


  async isSubmit(data) {
    if (!data) return true;
    let show = true;
    const { deliveryCoKey, returnAppKey, registerCutStockKey } = data;
    if (deliveryCoKey || returnAppKey || registerCutStockKey)
      show = false
    return show;
  }

}
